export default __webpack_public_path__ + "static/media/vehicle.e03f929f.svg";